var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"padding":"10px","font-size":"27px"},attrs:{"color":"primary"},on:{"click":_vm.handleClick}},[_vm._v("Starta Solarium Karlskoga")])}
var staticRenderFns = []

export { render, staticRenderFns }